import { render, staticRenderFns } from "./CarWashMenejerList.vue?vue&type=template&id=38c54818&"
import script from "@/views/Authed/CarWashAdministration/CarWashMenejerList/CarWashMenejerList.js?vue&type=script&lang=js&"
export * from "@/views/Authed/CarWashAdministration/CarWashMenejerList/CarWashMenejerList.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports